import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { updateConfig } from "../../../../../../store/slices/Branches/branchSlice";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import {
  updateRateDetails,
  updateFormData,
} from "../../../../../../store/slices/Branches/branchRateFormSlice";
import * as Yup from "yup";
import { useGetBasicDataQuery } from "../../../../../../store/queries/global";

const useRemittance = ({ refetch, closeModal }) => {
  const dispatch = useDispatch();

  const { selectedItemsDetails } = useSelector((state) => state.branchRateForm);
  const { selectedId } = useSelector((state) => state.branch);
  const { data: formData = {} } = useGetBasicDataQuery();

  const remittanceDetails =
    selectedItemsDetails !== ""
      ? selectedItemsDetails?.remittance_details?.Cash ||
        selectedItemsDetails?.remittance_details
      : null;

  // read the Cash section's locked flag to disable the section when locked
  const isCashLocked = Boolean(remittanceDetails?.locked);

  const validation = Yup.object({
    cash_markup_value: Yup.number().when("cash_markup_type", {
      is: 2,
      then: (schema) =>
        schema
          .min(0, "Value must be at least 0")
          .max(100, "Value must be at most 100"),
      otherwise: (schema) => schema,
    }),
  });

  const formik = useFormik({
    initialValues: {
      cash_rate: remittanceDetails?.rate ?? "",
      cash_markup_type: remittanceDetails?.markup_type ?? "",
      cash_markup_value: remittanceDetails?.markup_value ?? "",
      cash_forex_rate: remittanceDetails?.total_amount ?? "",
      cash_status: remittanceDetails?.status ?? 0,
    },

    validationSchema: validation,
    enableReinitialize: true,
    validateOnChange: true,
    validateOnMount: true,
    onSubmit: (values, { resetForm }) => {
      let obj = {
        branch_currency_id: selectedId,
        type: 3,
        product: [
          {
            id: remittanceDetails?.id,
            markup_type: values?.cash_markup_type,
            markup_value: +values?.cash_markup_value ?? 0,
            rate: values?.cash_rate,
            total_amount: values.cash_forex_rate,
            status: +values?.cash_status ?? 0,
          },
        ],
      };

      dispatch(updateRateDetails(obj)).then((response) => {
        if (response?.payload?.data?.success) {
          resetForm();
          closeModal?.();
          refetch();
          dispatch(
            updateConfig((state) => {
              state.showCreateModal = false;
            })
          );
          dispatch(
            updateConfig((state) => {
              state.clearSelection = true;
            })
          );

          toast.success(response?.payload?.data?.message);
        } else if (!response?.payload?.status) {
          if (response?.payload?.data[`product.0.total_amount`]) {
            formik.setFieldError(
              "cash_markup_value",
              response?.payload?.data[`product.0.total_amount`]
            );
          }
        } else formik.setErrors(response?.payload?.message);
      });
    },
  });

  // updating the completed percentage
  const remittanceFields = ["cash_markup_value"];

  var completedFields = remittanceFields?.filter((field) => {
    return !!!formik?.errors[field];
  });

  const completedPercentageRemittance =
    (completedFields.length / remittanceFields.length) * 100;

  useEffect(() => {
    dispatch(
      updateFormData((state) => {
        state.CompletedPercentage = {
          ...state.CompletedPercentage,
          Remittance: completedPercentageRemittance,
        };
      })
    );
    //eslint-disable-next-line
  }, [completedPercentageRemittance]);

  const handleCloseModal = () => {
    dispatch(
      updateConfig((state) => {
        state.showCreateModal = false;
      })
    );
  };

  const setTypeFieldValue = (id) => {
    if (formik.values?.cash_markup_value) {
      handleChangeCashForex(formik.values?.cash_markup_value, id);
    }
  };

  const handleChangeCashForex = (e, id) => {
    if (e.target) {
      formik.setFieldValue("cash_markup_value", e.target.value);
    } else {
      formik.setFieldValue("cash_markup_value", e);
    }

    const percentage = Number(
      e?.target?.value ?? formik.values?.cash_markup_value
    );
    const cashRate = Number(formik.values?.cash_rate) || 0;
    const cashMarkup = Math.abs(percentage) || 0;
    let rate = 0;

    if (id === 1) {
      const formattedRate = percentage.toFixed(4);
      formik.setFieldValue("cash_forex_rate", formattedRate);
    } else if (id === 2) {
      if (percentage > 0) {
        rate = cashRate + cashRate * (cashMarkup / 100);
      } else if (percentage < 0) {
        rate = cashRate - cashRate * (cashMarkup / 100);
      } else {
        rate = cashRate;
      }
      const formattedRate = rate.toFixed(4);
      formik.setFieldValue("cash_forex_rate", formattedRate);
    } else {
      rate = cashRate + percentage;
      const formattedRate = rate.toFixed(4);
      formik.setFieldValue("cash_forex_rate", formattedRate);
    }
  };

  return {
    formik,
    formData,
    isCashLocked,
    handleCloseModal,
    handleChangeCashForex,
    setTypeFieldValue,
  };
};

export default useRemittance;
